import { useEffect, useState } from "react";
import { Tag } from "lucide-react";
import { useAuth, PROMO_KEY } from "@/context/AuthContext";
import { getMyPromo, lookupPromo } from "@/lib/api";

export function PromoBanner({ className = "" }) {
  const { user } = useAuth();
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    if (user === null) return;
    let cancelled = false;
    const stored = localStorage.getItem(PROMO_KEY);
    const req = user ? getMyPromo().then((p) => p || (stored ? lookupPromo(stored) : null)) : stored ? lookupPromo(stored) : Promise.resolve(null);
    req
      .then((p) => !cancelled && setPromo(p && !p.used ? p : null))
      .catch(() => !cancelled && setPromo(null));
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (!promo) return null;
  return (
    <div data-testid="promo-banner" className={`flex items-center gap-3 border border-[#f59e0b] bg-[#f59e0b]/10 px-4 py-3 ${className}`}>
      <Tag className="w-4 h-4 text-[#f59e0b] shrink-0" />
      <span className="text-sm">
        Code <b data-testid="promo-banner-code" className="mono text-[#f59e0b]">{promo.code}</b>: {promo.discount_pct}% off your first payment, applied automatically at checkout.
      </span>
    </div>
  );
}
